var countryFlags = {
  'US': '\u{1F1FA}\u{1F1F8}',
  'CA': '\u{1F1E8}\u{1F1E6}',
  'FR': '\u{1F1EB}\u{1F1F7}',
  'NL': '\u{1F1F3}\u{1F1F1}',
  'DE': '\u{1F1E9}\u{1F1EA}',
  'GB': '\u{1F1EC}\u{1F1E7}',
  'IT': '\u{1F1EE}\u{1F1F9}',
  'ES': '\u{1F1EA}\u{1F1F8}',
  'CN': '\u{1F1E8}\u{1F1F3}',
  'JP': '\u{1F1EF}\u{1F1F5}',
  'BR': '\u{1F1E7}\u{1F1F7}',
  'IN': '\u{1F1EE}\u{1F1F3}',
  'RU': '\u{1F1F7}\u{1F1FA}',
  'ZA': '\u{1F1FF}\u{1F1E6}',
  'AU': '\u{1F1E6}\u{1F1FA}',
  'NZ': '\u{1F1F3}\u{1F1FF}',
  'MX': '\u{1F1F2}\u{1F1FD}',
  'AR': '\u{1F1E6}\u{1F1F7}',
  'CL': '\u{1F1E8}\u{1F1F1}',
  'CO': '\u{1F1E8}\u{1F1F4}',
  'PE': '\u{1F1F5}\u{1F1EA}',
  'VE': '\u{1F1FB}\u{1F1EA}',
  'EC': '\u{1F1EA}\u{1F1E8}',
  'GT': '\u{1F1EC}\u{1F1F9}',
  'HN': '\u{1F1ED}\u{1F1F3}',
  'SA': '\u{1F1F8}\u{1F1E6}',
  'AE': '\u{1F1E6}\u{1F1EA}',
  'TR': '\u{1F1F9}\u{1F1F7}',
  'TH': '\u{1F1F9}\u{1F1ED}',
  'MY': '\u{1F1F2}\u{1F1FE}',
  'SG': '\u{1F1F8}\u{1F1EC}',
  'ID': '\u{1F1EE}\u{1F1E9}',
  'PH': '\u{1F1F5}\u{1F1ED}',
  'VN': '\u{1F1FB}\u{1F1F3}',
  'KR': '\u{1F1F0}\u{1F1F7}',
  'KP': '\u{1F1F0}\u{1F1F5}',
  'SE': '\u{1F1F8}\u{1F1EA}',
  'NO': '\u{1F1F3}\u{1F1F4}',
  'FI': '\u{1F1EB}\u{1F1EE}',
  'DK': '\u{1F1E9}\u{1F1F0}',
  'IS': '\u{1F1EE}\u{1F1F8}',
  'IE': '\u{1F1EE}\u{1F1EA}',
  'CH': '\u{1F1E8}\u{1F1ED}',
  'PT': '\u{1F1F5}\u{1F1F9}',
  'BE': '\u{1F1E7}\u{1F1EA}',
  'LU': '\u{1F1F1}\u{1F1FA}',
  'PL': '\u{1F1F5}\u{1F1F1}',
  'CZ': '\u{1F1E8}\u{1F1FF}',
  'SK': '\u{1F1F8}\u{1F1F0}',
  'HU': '\u{1F1ED}\u{1F1FA}',
  'AT': '\u{1F1E6}\u{1F1F9}',
  'LI': '\u{1F1F1}\u{1F1EE}',
  'GR': '\u{1F1EC}\u{1F1F7}',
  'BG': '\u{1F1E7}\u{1F1EC}',
  'RO': '\u{1F1F7}\u{1F1F4}',
  'UA': '\u{1F1FA}\u{1F1E6}',
  'BY': '\u{1F1E7}\u{1F1FE}',
  'LT': '\u{1F1F1}\u{1F1F9}',
  'LV': '\u{1F1F1}\u{1F1FB}',
  'EE': '\u{1F1EA}\u{1F1EA}',
  'MD': '\u{1F1F2}\u{1F1E9}',
  'AM': '\u{1F1E6}\u{1F1F2}',
  'GE': '\u{1F1EC}\u{1F1EA}',
  'AZ': '\u{1F1E6}\u{1F1FF}',
  'IR': '\u{1F1EE}\u{1F1F7}',
  'IQ': '\u{1F1EE}\u{1F1F6}',
  'SY': '\u{1F1F8}\u{1F1FE}',
  'LB': '\u{1F1F1}\u{1F1E7}',
  'JO': '\u{1F1EF}\u{1F1F4}',
  'IL': '\u{1F1EE}\u{1F1F1}',
  'EG': '\u{1F1EA}\u{1F1EC}',
  'MA': '\u{1F1F2}\u{1F1E6}',
  'DZ': '\u{1F1E9}\u{1F1FF}',
  'TN': '\u{1F1F9}\u{1F1F3}',
  'LY': '\u{1F1F1}\u{1F1FE}',
  'GM': '\u{1F1EC}\u{1F1F2}',
  'SN': '\u{1F1F8}\u{1F1F3}',
  'MR': '\u{1F1F2}\u{1F1F7}',
  'ML': '\u{1F1F2}\u{1F1F1}',
  'GN': '\u{1F1EC}\u{1F1F3}',
  'CI': '\u{1F1E8}\u{1F1EE}',
  'BF': '\u{1F1E7}\u{1F1EB}',
  'NE': '\u{1F1F3}\u{1F1EA}',
  'TG': '\u{1F1F9}\u{1F1EC}',
  'BJ': '\u{1F1E7}\u{1F1EF}',
  'NG': '\u{1F1F3}\u{1F1EC}',
  'CM': '\u{1F1E8}\u{1F1F2}',
  'GA': '\u{1F1EC}\u{1F1E6}',
  'CG': '\u{1F1E8}\u{1F1EC}',
  'CD': '\u{1F1E8}\u{1F1E9}',
  'AO': '\u{1F1E6}\u{1F1F4}',
  'GW': '\u{1F1EC}\u{1F1FC}',
  'SC': '\u{1F1F8}\u{1F1E8}',
  'SD': '\u{1F1F8}\u{1F1E9}',
  'RW': '\u{1F1F7}\u{1F1FC}',
  'ET': '\u{1F1EA}\u{1F1F9}',
  'SO': '\u{1F1F8}\u{1F1F4}',
  'DJ': '\u{1F1E9}\u{1F1EF}',
  'KE': '\u{1F1F0}\u{1F1EA}',
  'TZ': '\u{1F1F9}\u{1F1FF}',
  'UG': '\u{1F1FA}\u{1F1EC}',
  'BI': '\u{1F1E7}\u{1F1EE}',
  'MZ': '\u{1F1F2}\u{1F1FF}',
  'ZM': '\u{1F1FF}\u{1F1F2}',
  'MW': '\u{1F1F2}\u{1F1FC}',
  'LS': '\u{1F1F1}\u{1F1F8}',
  'BW': '\u{1F1E7}\u{1F1FC}',
  'NA': '\u{1F1F3}\u{1F1E6}',
  'SZ': '\u{1F1F8}\u{1F1FF}',
  'HK': '\u{1F1ED}\u{1F1F0}',
  'BH': '\u{1F1E7}\u{1F1ED}'
};

var countryNames = {
  'US': { 'en': 'United States', 'fr': '\u00C9tats-Unis', 'nl': 'Verenigde Staten', 'de': 'Vereinigte Staaten', 'es': 'Estados Unidos' },
  'CA': { 'en': 'Canada', 'fr': 'Canada', 'nl': 'Canada', 'de': 'Kanada', 'es': 'Canad\u00E1' },
  'FR': { 'en': 'France', 'fr': 'France', 'nl': 'Frankrijk', 'de': 'Frankreich', 'es': 'Francia' },
  'NL': { 'en': 'Netherlands', 'fr': 'Pays-Bas', 'nl': 'Nederland', 'de': 'Niederlande', 'es': 'Pa\u00EDses Bajos' },
  'DE': { 'en': 'Germany', 'fr': 'Allemagne', 'nl': 'Duitsland', 'de': 'Deutschland', 'es': 'Alemania' },
  'GB': { 'en': 'United Kingdom', 'fr': 'Royaume-Uni', 'nl': 'Verenigd Koninkrijk', 'de': 'Vereinigtes K\u00F6nigreich', 'es': 'Reino Unido' },
  'IT': { 'en': 'Italy', 'fr': 'Italie', 'nl': 'Itali\u00EB', 'de': 'Italien', 'es': 'Italia' },
  'ES': { 'en': 'Spain', 'fr': 'Espagne', 'nl': 'Spanje', 'de': 'Spanien', 'es': 'Espa\u00F1a' },
  'CN': { 'en': 'China', 'fr': 'Chine', 'nl': 'China', 'de': 'China', 'es': 'China' },
  'JP': { 'en': 'Japan', 'fr': 'Japon', 'nl': 'Japan', 'de': 'Japan', 'es': 'Jap\u00F3n' },
  'BR': { 'en': 'Brazil', 'fr': 'Br\u00E9sil', 'nl': 'Brazili\u00EB', 'de': 'Brasilien', 'es': 'Brasil' },
  'IN': { 'en': 'India', 'fr': 'Inde', 'nl': 'India', 'de': 'Indien', 'es': 'India' },
  'RU': { 'en': 'Russia', 'fr': 'Russie', 'nl': 'Rusland', 'de': 'Russland', 'es': 'Rusia' },
  'ZA': { 'en': 'South Africa', 'fr': 'Afrique du Sud', 'nl': 'Zuid-Afrika', 'de': 'S\u00FCdafrika', 'es': 'Sud\u00E1frica' },
  'AU': { 'en': 'Australia', 'fr': 'Australie', 'nl': 'Australi\u00EB', 'de': 'Australien', 'es': 'Australia' },
  'NZ': { 'en': 'New Zealand', 'fr': 'Nouvelle-Z\u00E9lande', 'nl': 'Nieuw-Zeeland', 'de': 'Neuseeland', 'es': 'Nueva Zelanda' },
  'MX': { 'en': 'Mexico', 'fr': 'Mexique', 'nl': 'Mexico', 'de': 'Mexiko', 'es': 'M\u00E9xico' },
  'AR': { 'en': 'Argentina', 'fr': 'Argentine', 'nl': 'Argentini\u00EB', 'de': 'Argentinien', 'es': 'Argentina' },
  'CL': { 'en': 'Chile', 'fr': 'Chili', 'nl': 'Chili', 'de': 'Chile', 'es': 'Chile' },
  'CO': { 'en': 'Colombia', 'fr': 'Colombie', 'nl': 'Colombia', 'de': 'Kolumbien', 'es': 'Colombia' },
  'PE': { 'en': 'Peru', 'fr': 'P\u00E9rou', 'nl': 'Peru', 'de': 'Peru', 'es': 'Per\u00FA' },
  'VE': { 'en': 'Venezuela', 'fr': 'Venezuela', 'nl': 'Venezuela', 'de': 'Venezuela', 'es': 'Venezuela' },
  'EC': { 'en': 'Ecuador', 'fr': '\u00C9quateur', 'nl': 'Ecuador', 'de': 'Ecuador', 'es': 'Ecuador' },
  'GT': { 'en': 'Guatemala', 'fr': 'Guatemala', 'nl': 'Guatemala', 'de': 'Guatemala', 'es': 'Guatemala' },
  'HN': { 'en': 'Honduras', 'fr': 'Honduras', 'nl': 'Honduras', 'de': 'Honduras', 'es': 'Honduras' },
  'SA': { 'en': 'Saudi Arabia', 'fr': 'Arabie Saoudite', 'nl': 'Saoedi-Arabi\u00EB', 'de': 'Saudi-Arabien', 'es': 'Arabia Saudita' },
  'AE': { 'en': 'United Arab Emirates', 'fr': '\u00C9mirats Arabes Unis', 'nl': 'Verenigde Arabische Emiraten', 'de': 'Vereinigte Arabische Emirate', 'es': 'Emiratos \u00C1rabes Unidos' },
  'TR': { 'en': 'Turkey', 'fr': 'Turquie', 'nl': 'Turkije', 'de': 'T\u00FCrkei', 'es': 'Turqu\u00EDa' },
  'TH': { 'en': 'Thailand', 'fr': 'Tha\u00EFlande', 'nl': 'Thailand', 'de': 'Thailand', 'es': 'Tailandia' },
  'MY': { 'en': 'Malaysia', 'fr': 'Malaisie', 'nl': 'Maleisi\u00EB', 'de': 'Malaysia', 'es': 'Malasia' },
  'SG': { 'en': 'Singapore', 'fr': 'Singapour', 'nl': 'Singapore', 'de': 'Singapur', 'es': 'Singapur' },
  'ID': { 'en': 'Indonesia', 'fr': 'Indon\u00E9sie', 'nl': 'Indonesi\u00EB', 'de': 'Indonesien', 'es': 'Indonesia' },
  'PH': { 'en': 'Philippines', 'fr': 'Philippines', 'nl': 'Filipijnen', 'de': 'Philippinen', 'es': 'Filipinas' },
  'VN': { 'en': 'Vietnam', 'fr': 'Vietnam', 'nl': 'Vietnam', 'de': 'Vietnam', 'es': 'Vietnam' },
  'KR': { 'en': 'South Korea', 'fr': 'Cor\u00E9e du Sud', 'nl': 'Zuid-Korea', 'de': 'S\u00FCdkorea', 'es': 'Corea del Sur' },
  'KP': { 'en': 'North Korea', 'fr': 'Cor\u00E9e du Nord', 'nl': 'Noord-Korea', 'de': 'Nordkorea', 'es': 'Corea del Norte' },
  'SE': { 'en': 'Sweden', 'fr': 'Su\u00E8de', 'nl': 'Zweden', 'de': 'Schweden', 'es': 'Suecia' },
  'NO': { 'en': 'Norway', 'fr': 'Norv\u00E8ge', 'nl': 'Noorwegen', 'de': 'Norwegen', 'es': 'Noruega' },
  'FI': { 'en': 'Finland', 'fr': 'Finlande', 'nl': 'Finland', 'de': 'Finnland', 'es': 'Finlandia' },
  'DK': { 'en': 'Denmark', 'fr': 'Danemark', 'nl': 'Denemarken', 'de': 'D\u00E4nemark', 'es': 'Dinamarca' },
  'IS': { 'en': 'Iceland', 'fr': 'Islande', 'nl': 'IJsland', 'de': 'Island', 'es': 'Islandia' },
  'IE': { 'en': 'Ireland', 'fr': 'Irlande', 'nl': 'Ierland', 'de': 'Irland', 'es': 'Irlanda' },
  'CH': { 'en': 'Switzerland', 'fr': 'Suisse', 'nl': 'Zwitserland', 'de': 'Schweiz', 'es': 'Suiza' },
  'PT': { 'en': 'Portugal', 'fr': 'Portugal', 'nl': 'Portugal', 'de': 'Portugal', 'es': 'Portugal' },
  'BE': { 'en': 'Belgium', 'fr': 'Belgique', 'nl': 'Belgi\u00EB', 'de': 'Belgien', 'es': 'B\u00E9lgica' },
  'LU': { 'en': 'Luxembourg', 'fr': 'Luxembourg', 'nl': 'Luxemburg', 'de': 'Luxemburg', 'es': 'Luxemburgo' },
  'PL': { 'en': 'Poland', 'fr': 'Pologne', 'nl': 'Polen', 'de': 'Polen', 'es': 'Polonia' },
  'CZ': { 'en': 'Czech Republic', 'fr': 'R\u00E9publique Tch\u00E8que', 'nl': 'Tsjechi\u00EB', 'de': 'Tschechien', 'es': 'Rep\u00FAblica Checa' },
  'SK': { 'en': 'Slovakia', 'fr': 'Slovaquie', 'nl': 'Slowakije', 'de': 'Slowakei', 'es': 'Eslovaquia' },
  'HU': { 'en': 'Hungary', 'fr': 'Hongrie', 'nl': 'Hongarije', 'de': 'Ungarn', 'es': 'Hungr\u00EDa' },
  'AT': { 'en': 'Austria', 'fr': 'Autriche', 'nl': 'Oostenrijk', 'de': '\u00D6sterreich', 'es': 'Austria' },
  'LI': { 'en': 'Liechtenstein', 'fr': 'Liechtenstein', 'nl': 'Liechtenstein', 'de': 'Liechtenstein', 'es': 'Liechtenstein' },
  'GR': { 'en': 'Greece', 'fr': 'Gr\u00E8ce', 'nl': 'Griekenland', 'de': 'Griechenland', 'es': 'Grecia' },
  'BG': { 'en': 'Bulgaria', 'fr': 'Bulgarie', 'nl': 'Bulgarije', 'de': 'Bulgarien', 'es': 'Bulgaria' },
  'RO': { 'en': 'Romania', 'fr': 'Roumanie', 'nl': 'Roemenij\u00EB', 'de': 'Rum\u00E4nien', 'es': 'Ruman\u00EDa' },
  'UA': { 'en': 'Ukraine', 'fr': 'Ukraine', 'nl': 'Oekra\u00EFne', 'de': 'Ukraine', 'es': 'Ucrania' },
  'BY': { 'en': 'Belarus', 'fr': 'Bi\u00E9lorussie', 'nl': 'Wit-Rusland', 'de': 'Wei\u00DFrussland', 'es': 'Bielorrusia' },
  'LT': { 'en': 'Lithuania', 'fr': 'Lituanie', 'nl': 'Litouwen', 'de': 'Litauen', 'es': 'Lituania' },
  'LV': { 'en': 'Latvia', 'fr': 'Lettonie', 'nl': 'Letland', 'de': 'Lettland', 'es': 'Letonia' },
  'EE': { 'en': 'Estonia', 'fr': 'Estonie', 'nl': 'Estland', 'de': 'Estland', 'es': 'Estonia' },
  'MD': { 'en': 'Moldova', 'fr': 'Moldavie', 'nl': 'Moldavi\u00EB', 'de': 'Moldawien', 'es': 'Moldavia' },
  'AM': { 'en': 'Armenia', 'fr': 'Arm\u00E9nie', 'nl': 'Armeni\u00EB', 'de': 'Armenien', 'es': 'Armenia' },
  'GE': { 'en': 'Georgia', 'fr': 'G\u00E9orgie', 'nl': 'Georgi\u00EB', 'de': 'Georgien', 'es': 'Georgia' },
  'AZ': { 'en': 'Azerbaijan', 'fr': 'Azerba\u00EFdjan', 'nl': 'Azerbeidzjan', 'de': 'Aserbaidschan', 'es': 'Azerbaiy\u00E1n' },
  'IR': { 'en': 'Iran', 'fr': 'Iran', 'nl': 'Iran', 'de': 'Iran', 'es': 'Ir\u00E1n' },
  'IQ': { 'en': 'Iraq', 'fr': 'Irak', 'nl': 'Irak', 'de': 'Irak', 'es': 'Irak' },
  'SY': { 'en': 'Syria', 'fr': 'Syrie', 'nl': 'Syri\u00EB', 'de': 'Syrien', 'es': 'Siria' },
  'LB': { 'en': 'Lebanon', 'fr': 'Liban', 'nl': 'Libanon', 'de': 'Libanon', 'es': 'L\u00EDbano' },
  'JO': { 'en': 'Jordan', 'fr': 'Jordanie', 'nl': 'Jordani\u00EB', 'de': 'Jordanien', 'es': 'Jordania' },
  'IL': { 'en': 'Israel', 'fr': 'Isra\u00EBl', 'nl': 'Isra\u00EBl', 'de': 'Israel', 'es': 'Israel' },
  'EG': { 'en': 'Egypt', 'fr': '\u00C9gypte', 'nl': 'Egypte', 'de': '\u00C4gypten', 'es': 'Egipto' },
  'MA': { 'en': 'Morocco', 'fr': 'Maroc', 'nl': 'Marokko', 'de': 'Marokko', 'es': 'Marruecos' },
  'DZ': { 'en': 'Algeria', 'fr': 'Alg\u00E9rie', 'nl': 'Algerije', 'de': 'Algerien', 'es': 'Argelia' },
  'TN': { 'en': 'Tunisia', 'fr': 'Tunisie', 'nl': 'Tunesi\u00EB', 'de': 'Tunesien', 'es': 'T\u00FAnez' },
  'LY': { 'en': 'Libya', 'fr': 'Libye', 'nl': 'Libi\u00EB', 'de': 'Libyen', 'es': 'Libia' },
  'GM': { 'en': 'Gambia', 'fr': 'Gambie', 'nl': 'Gambia', 'de': 'Gambia', 'es': 'Gambia' },
  'SN': { 'en': 'Senegal', 'fr': 'S\u00E9n\u00E9gal', 'nl': 'Senegal', 'de': 'Senegal', 'es': 'Senegal' },
  'MR': { 'en': 'Mauritania', 'fr': 'Mauritanie', 'nl': 'Mauritani\u00EB', 'de': 'Mauretanien', 'es': 'Mauritania' },
  'ML': { 'en': 'Mali', 'fr': 'Mali', 'nl': 'Mali', 'de': 'Mali', 'es': 'Mal\u00ED' },
  'GN': { 'en': 'Guinea', 'fr': 'Guin\u00E9e', 'nl': 'Guinee', 'de': 'Guinea', 'es': 'Guinea' },
  'CI': { 'en': 'Ivory Coast', 'fr': 'C\u00F4te d\'Ivoire', 'nl': 'Ivoorkust', 'de': 'Elfenbeink\u00FCste', 'es': 'Costa de Marfil' },
  'BF': { 'en': 'Burkina Faso', 'fr': 'Burkina Faso', 'nl': 'Burkina Faso', 'de': 'Burkina Faso', 'es': 'Burkina Faso' },
  'NE': { 'en': 'Niger', 'fr': 'Niger', 'nl': 'Niger', 'de': 'Niger', 'es': 'N\u00EDger' },
  'TG': { 'en': 'Togo', 'fr': 'Togo', 'nl': 'Togo', 'de': 'Togo', 'es': 'Togo' },
  'BJ': { 'en': 'Benin', 'fr': 'B\u00E9nin', 'nl': 'Benin', 'de': 'Benin', 'es': 'Ben\u00EDn' },
  'NG': { 'en': 'Nigeria', 'fr': 'Nigeria', 'nl': 'Nigeria', 'de': 'Nigeria', 'es': 'Nigeria' },
  'CM': { 'en': 'Cameroon', 'fr': 'Cameroun', 'nl': 'Kameroen', 'de': 'Kamerun', 'es': 'Camer\u00FAn' },
  'GA': { 'en': 'Gabon', 'fr': 'Gabon', 'nl': 'Gabon', 'de': 'Gabun', 'es': 'Gab\u00F3n' },
  'CG': { 'en': 'Republic of the Congo', 'fr': 'R\u00E9publique du Congo', 'nl': 'Republiek Congo', 'de': 'Kongo', 'es': 'Rep\u00FAblica del Congo' },
  'CD': { 'en': 'Democratic Republic of the Congo', 'fr': 'R\u00E9publique D\u00E9mocratique du Congo', 'nl': 'Democratische Republiek Congo', 'de': 'Kongo (Dem. Rep.)', 'es': 'Rep\u00FAblica Democr\u00E1tica del Congo' },
  'AO': { 'en': 'Angola', 'fr': 'Angola', 'nl': 'Angola', 'de': 'Angola', 'es': 'Angola' },
  'GW': { 'en': 'Guinea-Bissau', 'fr': 'Guin\u00E9e-Bissau', 'nl': 'Guinee-Bissau', 'de': 'Guinea-Bissau', 'es': 'Guinea-Bis\u00E1u' },
  'SC': { 'en': 'Seychelles', 'fr': 'Seychelles', 'nl': 'Seychellen', 'de': 'Seychellen', 'es': 'Seychelles' },
  'SD': { 'en': 'Sudan', 'fr': 'Soudan', 'nl': 'Soedan', 'de': 'Sudan', 'es': 'Sud\u00E1n' },
  'RW': { 'en': 'Rwanda', 'fr': 'Rwanda', 'nl': 'Rwanda', 'de': 'Ruanda', 'es': 'Ruanda' },
  'ET': { 'en': 'Ethiopia', 'fr': '\u00C9thiopie', 'nl': 'Ethiopi\u00EB', 'de': '\u00C4thiopien', 'es': 'Etiop\u00EDa' },
  'SO': { 'en': 'Somalia', 'fr': 'Somalie', 'nl': 'Somali\u00EB', 'de': 'Somalia', 'es': 'Somalia' },
  'DJ': { 'en': 'Djibouti', 'fr': 'Djibouti', 'nl': 'Djibouti', 'de': 'Dschibuti', 'es': 'Yibuti' },
  'KE': { 'en': 'Kenya', 'fr': 'Kenya', 'nl': 'Kenia', 'de': 'Kenia', 'es': 'Kenia' },
  'TZ': { 'en': 'Tanzania', 'fr': 'Tanzanie', 'nl': 'Tanzania', 'de': 'Tansania', 'es': 'Tanzania' },
  'UG': { 'en': 'Uganda', 'fr': 'Ouganda', 'nl': 'Oeganda', 'de': 'Uganda', 'es': 'Uganda' },
  'BI': { 'en': 'Burundi', 'fr': 'Burundi', 'nl': 'Burundi', 'de': 'Burundi', 'es': 'Burundi' },
  'MZ': { 'en': 'Mozambique', 'fr': 'Mozambique', 'nl': 'Mozambique', 'de': 'Mosambik', 'es': 'Mozambique' },
  'ZM': { 'en': 'Zambia', 'fr': 'Zambie', 'nl': 'Zambia', 'de': 'Sambia', 'es': 'Zambia' },
  'MW': { 'en': 'Malawi', 'fr': 'Malawi', 'nl': 'Malawi', 'de': 'Malawi', 'es': 'Malaui' },
  'LS': { 'en': 'Lesotho', 'fr': 'Lesotho', 'nl': 'Lesotho', 'de': 'Lesotho', 'es': 'Lesoto' },
  'BW': { 'en': 'Botswana', 'fr': 'Botswana', 'nl': 'Botswana', 'de': 'Botswana', 'es': 'Botsuana' },
  'NA': { 'en': 'Namibia', 'fr': 'Namibie', 'nl': 'Namibi\u00EB', 'de': 'Namibia', 'es': 'Namibia' },
  'SZ': { 'en': 'Eswatini', 'fr': 'Eswatini', 'nl': 'Eswatini', 'de': 'Eswatini', 'es': 'Esuatini' },
  'HK': { 'en': 'Hong Kong', 'fr': 'Hong Kong', 'nl': 'Hongkong', 'de': 'Hongkong', 'es': 'Hong Kong' },
  'BH': { 'en': 'Bahrain', 'fr': 'Bahrain', 'nl': 'Bahrain', 'de': 'Bahrain', 'es': 'Bahrain' }
};

async function fetchLocationInfo() {
  try {
    var response = await fetch('/browsing_context_suggestions.json');
    if (!response.ok) throw new Error('Failed to fetch location data');

    var data = await response.json();
    var countryCode = (data && data.detected_values && data.detected_values.country && data.detected_values.country.handle) || 'US';
    updateLocationInfo(countryCode);
  } catch (error) {
    console.error('Location fetch error:', error);
    updateLocationInfo('US');
  }
}

function updateLocationInfo(countryCode) {
  if (!countryCode) return;

  var flag = countryFlags[countryCode] || '\u{1F4E6}';
  var lang = document.documentElement.lang || 'en';
  var countryName = (countryNames[countryCode] && countryNames[countryCode][lang]) || countryCode;

  var locationLabel = document.getElementById('country-flag-script') ? document.getElementById('country-flag-script').getAttribute('data-location-label') : '';
  var toLabel = document.getElementById('country-flag-script') ? document.getElementById('country-flag-script').getAttribute('data-to-label') : '';

  var shippingMessage = flag + ' | ' + locationLabel + ' <span style="text-decoration: underline; color: black; font-weight:bold;">' + countryName + '</span>';
  var shippingMessageCart = toLabel + ' ' + flag + ' ' + countryCode;

  var locationInfoP = document.getElementById('locationinfop');
  var locationInfoCart = document.getElementById('locationinfocart');

  if (locationInfoP) locationInfoP.innerHTML = shippingMessage;
  if (locationInfoCart) locationInfoCart.innerHTML = shippingMessageCart;
}

document.addEventListener('DOMContentLoaded', fetchLocationInfo);
document.addEventListener('cart:change', fetchLocationInfo);
